export class CustomButton {
    label? : string;
    action? : (args? : any) => any;
    place? : 'right' | 'left';
    focus : boolean = false;
    main : boolean = false;

    constructor(label : string, action? : (args? : any) => any, place : 'right' | 'left' = 'right'){
        this.label = label;
        this.action = action;
        this.place = place;
    }
 }
